import { nameByPlatform } from "~/constants/platfroms";
import type { Platform } from "~/types/platform";

export interface IPlatformLogoSplit {
  visible: Platform[];
  hidden: Platform[];
  hiddenNames: string[];
  overflowLabel: string | null;
}

export const splitPlatformLogos = (
  platforms: readonly Platform[],
  max?: number
): IPlatformLogoSplit => {
  const unique = Array.from(new Set(platforms));
  const cap = max !== undefined && max >= 1 ? max : unique.length;
  const visible = unique.slice(0, cap);
  const hidden = unique.slice(cap);

  return {
    visible,
    hidden,
    hiddenNames: hidden.map((platform) => nameByPlatform[platform]),
    overflowLabel: hidden.length > 0 ? `+${hidden.length}` : null,
  };
};
